import { ProductsGrid } from "@similarweb/icons";

import type { IFiltersConfigCategoryItem } from "../types/category";
import type { CategoryFiltersConfig } from "../types/filtersConfig";
import { filtersConfigStatusMap } from "../types/filtersConfig";
import advancedFilteringI18nKeys from "../utils/i18n";

export const allCategory: IFiltersConfigCategoryItem = {
    id: "all",
    order: 0,
    icon: ProductsGrid,
    titleKey: advancedFilteringI18nKeys.category("all"),
    resolveCount: (totalCount) => totalCount,
};

/* Typed `<never>` so its empty filter list slots into a merge of any filter-instance type. */
export const allCategoryConfig: CategoryFiltersConfig<never> = {
    categoriesList: [allCategory],
    filtersList: Array.of<never>(),
    status: filtersConfigStatusMap.ready,
};
